import React from 'react'
import { useDirectlineStore } from '../Contexts/DirectlineContext'

interface NamedListElementType {
  text: string
  value: string
  display: string
  group?: string
}

interface NamedListAttachmentProps {
  value: Array<NamedListElementType>
  title?: string
  history?: boolean
  height?: number
}

const NamedListAttachment = ({ value, title, history, height }: NamedListAttachmentProps): JSX.Element => {
  const sendMessage = useDirectlineStore((state) => state.actions.sendMessage)

  const handleClick = (valueToSend: string): void => {
    sendMessage(valueToSend)
  }

  return (
    <div
      className='rf-w-full rf-p-4 rf-pb-8 rf-flex rf-flex-col rf-items-center rf-bg-cardFrameBackground rf-gap-4 rf-rounded'
      style={{
        height: height
      }}
    >
      {/* Title */}
      {title && <div className='rf-w-full rf-subtitle-size-auto rf-text-center rf-text-cardFrameText rf-font-bold'>{title}</div>}

      {/* Buttons */}
      <div className='rf-flex rf-flex-row rf-justify-center rf-items-center rf-flex-wrap rf-gap-3 large:rf-gap-4'>
        {value.map((item, key) => {
          return (
            <button key={key} className={`${item.display === 'primary' ? 'rf-card-button-positive' : 'rf-card-button'}`} onClick={history ? () => {} : () => handleClick(item.value)}>
              {item.text}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default NamedListAttachment
export type { NamedListElementType }
